import { User } from "../types/types";
import { fetchGet, fetchPost } from "../util/apiUtil";

export const loadUsers = () => fetchGet("players/GetAll");

export const updateUser = (user: User) => fetchPost("players/Update", user);
export const createUser = (user: User) => fetchPost("players/Create", user);
